/**
 * @ External Dependecies
 */
import styled from 'styled-components';

export const BackButton = styled.div`
marginBottom: 7,
marginRight: 15,
`;
